/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityMelcoModelsRole
 */
export interface IdentityMelcoModelsRole {
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsRole
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsRole
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsRole
     */
    name?: string | null;
}

export function IdentityMelcoModelsRoleFromJSON(json: any): IdentityMelcoModelsRole {
    return IdentityMelcoModelsRoleFromJSONTyped(json, false);
}

export function IdentityMelcoModelsRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsRole {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function IdentityMelcoModelsRoleToJSON(value?: IdentityMelcoModelsRole | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
    };
}


